import axios from 'axios'

// 根据环境设置不同的baseURL
const getBaseURL = () => {
  if (process.env.NODE_ENV === 'development') {
    return '/api' // 开发环境使用代理
  }
  return window.baseUrl || 'http://121.37.93.124:8001' // 生产环境
}

const instance = axios.create({
    baseURL: getBaseURL(),
    timeout: 40000
});

instance.interceptors.request.use(function(config) {
    console.log('发送请求:', config.url)
    return config;
}, function(error) {
    console.error('请求错误:', error)
    return Promise.reject(error);
});

instance.interceptors.response.use(function(response) {
    console.log('响应成功:', response.config.url)
    return response.status == 200 ? response.data : response;
}, function(error) {
    console.error('响应错误:', error)
    if (error.code === 'NETWORK_ERROR') {
        console.error('网络错误，请检查：')
        console.error('1. API服务器是否运行')
        console.error('2. 网络连接是否正常')
        console.error('3. 防火墙设置')
    }
    return Promise.reject(error);
});

export default instance;